import { ExpandLess, ExpandMore, ReportProblem, CheckCircle } from '@mui/icons-material'
import { Divider, Collapse, ListItemButton, ListItemIcon, ListItemText } from '@mui/material'
import * as parentCss from '@datasets/dataset-details/datasetHistoryV2/styled'
import { DatasetSubmissionIntegrationAssignment } from '@datasets/dataset-details/datasetHistoryV2/types'
import { outboundIntegrationAssignmentHasErrors } from '@datasets/dataset-details/datasetHistoryV2/utils'
import { OutboundBatchErrorItem, OutboundBatchSuccessItem } from './components'
import { t } from '@lingui/core/macro'

const OutboundBatch = ({ error, id, status, remoteJobId, history }) => {
  if (status === 'started') {
    return (
      <OutboundBatchSuccessItem
        id={id}
        key={id}
        remoteJobId={remoteJobId}
        updatedAt={history.updatedAt}
      >
        <parentCss.InProgressAlertTitle>{t`Started`}</parentCss.InProgressAlertTitle>
      </OutboundBatchSuccessItem>
    )
  }

  if (status === 'in progress') {
    return (
      <OutboundBatchSuccessItem
        id={id}
        key={id}
        remoteJobId={remoteJobId}
        updatedAt={history.updatedAt}
      >
        <parentCss.InProgressAlertTitle>{t`In progress`}</parentCss.InProgressAlertTitle>
      </OutboundBatchSuccessItem>
    )
  }

  if (status === 'error') {
    return (
      <OutboundBatchErrorItem
        error={error}
        id={id}
        key={id}
        remoteJobId={remoteJobId}
        updatedAt={history.updatedAt}
      />
    )
  }

  return (
    <OutboundBatchSuccessItem
      id={id}
      key={id}
      remoteJobId={remoteJobId}
      updatedAt={history.updatedAt}
    >
      <parentCss.SuccessAlertTitle>{t`Success`}</parentCss.SuccessAlertTitle>
    </OutboundBatchSuccessItem>
  )
}
interface IntegrationAssignmentItemProps {
  onClick: () => void
  open: boolean
  integrationAssignment: DatasetSubmissionIntegrationAssignment
}

export const IntegrationAssignmentItem = ({
  onClick,
  open,
  integrationAssignment,
}: IntegrationAssignmentItemProps) => (
  <>
    <ListItemButton key={integrationAssignment.id} onClick={onClick}>
      <ListItemIcon>
        {outboundIntegrationAssignmentHasErrors(integrationAssignment) ? (
          <ReportProblem color="error" />
        ) : (
          <CheckCircle color="success" />
        )}
      </ListItemIcon>
      <ListItemText primary={integrationAssignment.name} />
      {open ? <ExpandLess /> : <ExpandMore />}
    </ListItemButton>
    <Collapse in={open}>
      {integrationAssignment.orchestrationHistory.map(history =>
        history.batches?.map(({ error, id, status, remoteJobId }) => (
          <OutboundBatch
            key={id}
            error={error}
            id={id}
            status={status}
            remoteJobId={remoteJobId}
            history={history}
          />
        )),
      )}
    </Collapse>
    <Divider sx={{ marginTop: '10px' }} />
  </>
)
